<article class="m-accordion-group">
    <div class="m-accordion-group__header"
         :class="{ 'm--no-title' : !hasTitleSlot,
                   'm--has-secondary-content' : hasSecondaryContentSlot,
                   'm--is-toggle-link-left' : toggleLinkLeft }"
         v-if="hasTitleSlot || !concurrent">
        <div class="m-accordion-group__header-title"
             v-if="hasTitleSlot">
            <slot name="title"></slot>
        </div>
        <div class="m-accordion-group__secondary-content">
            <slot name="secondary-content"></slot>
            <div class="m-accordion-group__toggle-link"
                 v-if="!concurrent && !disabled">
                <m-link mode="button"
                        @click="openAllAccordions"
                        v-if="!isAllOpen"
                        ref="openAllButton">
                    <m-i18n k="m-accordion-group:open-all"></m-i18n>
                </m-link>
                <template v-if="!isAllOpen && !isAllClosed">&nbsp;&nbsp;|&nbsp;&nbsp;</template>
                <m-link mode="button"
                        @click="closeAllAccordions"
                        v-if="!isAllClosed"
                        ref="closeAllButton">
                    <m-i18n k="m-accordion-group:close-all"></m-i18n>
                </m-link>
            </div>
        </div>
    </div>
    <div class="m-accordion-group__body">
        <slot></slot>
    </div>
</article>
